import { Input, Label, TextArea } from '@/src/components/Antd';
import Row from '@/src/components/Layouts/Row/Row';
import SecretInput from '@/src/components/SecretInput';
import { Form } from 'antd';
import React, { Fragment } from 'react';
import { useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';

export default ({ handleResetInput, unlockEditable, disableEdit }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const params: any = useParams();
  const { uuid } = params;

  return (
    <Fragment>
      <Row
        elements={[
          {
            child: (
              <Form.Item
                name='merchantId'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n(
                      'storePayment.paymentEditPage.MerchantID',
                    )}*`}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n('storePayment.paymentEditPage.MerchantID'),
                    ),
                  },
                ]}>
                <Input size='large' maxLength={100} disabled={disableEdit} />
              </Form.Item>
            ),
          },
          {
            child: (
              <Form.Item
                name='apiV3Key'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n(
                      'storePayment.paymentEditPage.APIV3Key',
                    )}*`}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n('storePayment.paymentEditPage.APIV3Key'),
                    ),
                  },
                ]}>
                <SecretInput
                  editable={!uuid || unlockEditable.includes('apiV3Key')}
                  onEdit={() => handleResetInput('apiV3Key')}
                  secretProps={{ maxLength: 100 }}
                  disabled={disableEdit}
                />
              </Form.Item>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <Form.Item
                name='merchantApiPrivateKey'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n(
                      'storePayment.paymentEditPage.MerchantApiPrivateKey',
                    )}*`}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n(
                        'storePayment.paymentEditPage.MerchantApiPrivateKey',
                      ),
                    ),
                  },
                ]}>
                <TextArea size='small' disabled={disableEdit} />
              </Form.Item>
            ),
          },
          {
            child: (
              <Form.Item
                name='merchantApiSerialNumber'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n(
                      'storePayment.paymentEditPage.MerchantApiSerialNumber',
                    )}*`}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n(
                        'storePayment.paymentEditPage.MerchantApiSerialNumber',
                      ),
                    ),
                  },
                ]}>
                <Input size='large' maxLength={100} disabled={disableEdit} />
              </Form.Item>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <Form.Item
                name='wechatPayPublicKey'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n(
                      'storePayment.paymentEditPage.WechatPayPublicKey',
                    )}*`}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n(
                        'storePayment.paymentEditPage.WechatPayPublicKey',
                      ),
                    ),
                  },
                ]}>
                <TextArea size='small' disabled={disableEdit} />
              </Form.Item>
            ),
          },
          {
            child: (
              <Form.Item
                name='wechatPayPublicKeyId'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n(
                      'storePayment.paymentEditPage.WechatPayPublicKeyID',
                    )}*`}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n(
                        'storePayment.paymentEditPage.WechatPayPublicKeyID',
                      ),
                    ),
                  },
                ]}>
                <SecretInput
                  editable={
                    !uuid || unlockEditable.includes('wechatPayPublicKeyId')
                  }
                  onEdit={() => handleResetInput('wechatPayPublicKeyId')}
                  secretProps={{ maxLength: 100 }}
                  disabled={disableEdit}
                />
              </Form.Item>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <Form.Item
                name='merchantSerialNumber'
                labelCol={{
                  span: 24,
                }}
                label={
                  <Label
                    title={`${getI18n(
                      'storePayment.paymentEditPage.CertificateSerialNumber',
                    )}`}
                  />
                }>
                <Input size='large' maxLength={100} disabled={disableEdit} />
              </Form.Item>
            ),
          },
          {
            child: <></>,
          },
        ]}
      />
      <div>{getI18n('storePayment.paymentEditPage.wechatReminder')}</div>
    </Fragment>
  );
};
